import React, { useState } from "react";
import { Button, Card, Col, Container, Form, Nav, Row, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import pageSvg from "../assets/svg/forgot_password.svg";
import logo from "../assets/img/brandimg.png";

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);

    const auth = getAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!email) {
            setError('Please enter your email address');
            return;
        }

        try {
            setError('');
            setLoading(true);

            // Firebase password reset email
            await sendPasswordResetEmail(auth, email, {
                url: `${window.location.origin}/auth/signin`, // Redirect URL after password reset
                handleCodeInApp: true
            });

            setSuccess('Password reset link has been sent to your email!');
            setEmail(''); // Clear the form
        } catch (error) {
            console.error('Error sending reset email:', error);
            switch (error.code) {
                case 'auth/invalid-email':
                    setError('Invalid email address');
                    break;
                case 'auth/user-not-found':
                    setError('No account found with this email');
                    break;
                case 'auth/too-many-requests':
                    setError('Too many attempts. Please try again later');
                    break;
                default:
                    setError('Failed to send reset email. Please try again');
            }
        } finally {
            setLoading(false);
        }
    };

    document.body.classList.remove("sidebar-show");

    return (
        <div className="page-auth">
            <div className="header">
                <Container>
                    <img src={logo} alt="logo" className="header-logo" style={{ width: '170px', height: '170px' }}/>
                </Container>
            </div>

            <div className="content">
                <Container>
                    <Card className="card-auth">
                        <Card.Body className="text-center">
                            <div className="mb-5">
                                <object type="image/svg+xml" data={pageSvg} className="w-50" aria-label="svg image"></object>
                            </div>
                            <Card.Title>Reset your password</Card.Title>
                            <Card.Text className="mb-4">
                                Enter your email address and we will send you a link to reset your password.
                            </Card.Text>

                            {error && <Alert variant="danger">{error}</Alert>}
                            {success && <Alert variant="success">{success}</Alert>}

                            <Form onSubmit={handleSubmit}>
                                <Row className="g-2">
                                    <Col sm="8">
                                        <Form.Control
                                            type="email"
                                            placeholder="Enter email address"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            disabled={loading}
                                        />
                                    </Col>
                                    <Col sm="4">
                                        <Button
                                            variant="primary"
                                            type="submit"
                                            className="w-100"
                                            disabled={loading}
                                        >
                                            {loading ? 'Sending...' : 'Reset'}
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>

                            <div className="mt-4">
                                <Link to="/auth/signin" className="text-secondary">
                                    Back to Sign In
                                </Link>
                            </div>
                        </Card.Body>
                    </Card>
                </Container>
            </div>
        </div>
    );
}